import { z } from 'zod';

export const memberSchema = z.object({
	nome: z.string().min(3, 'Il nome deve avere almeno 3 caratteri').max(100, 'Nome troppo lungo'),
	tipo: z.enum(['residential', 'office', 'shop', 'sme', 'factory', 'public_administration', 'ets']),
	ruolo: z.enum(['consumer', 'producer', 'prosumer']),
	stato: z.enum(['verified', 'incomplete', 'pending', 'takeover', 'withdrawn']),
	email: z.string().email('Email non valida').or(z.literal('')).or(z.null()),
	comune: z.string().or(z.null()).or(z.literal('')),
	regione: z.string().or(z.null()).or(z.literal('')),
	note: z.string().or(z.null()).or(z.literal('')),
});

export type MemberFormData = z.infer<typeof memberSchema>;
